export default class AvailabilityInterval {
    constructor(experienceId = 0, guideId = 0, startDate = new Date(), endDate = new Date(), startTime = "09:00", frequency = 2, minPeople = 1, maxPeople = 10, isActive = true) {
        this.experienceId = experienceId;
        this.guideId = guideId;
        this.startDate = startDate;
        this.endDate = endDate;
        this.startTime = startTime;
        this.frequency = frequency;
        this.minPeople = minPeople;
        this.maxPeople = maxPeople;
        this.isActive = isActive;
    }

    isValid() {
        return this.experienceId > 0 && 
               this.guideId > 0 && 
               this.startDate && 
               this.endDate &&
               new Date(this.startDate) < new Date(this.endDate) &&
               this.startTime && 
               this.frequency > 0 &&
               this.minPeople > 0 && 
               this.maxPeople > 0 && 
               this.minPeople <= this.maxPeople;
    }

    // Helper method to format date for API
    getFormattedStartDate() {
        if (this.startDate instanceof Date) {
            return this.startDate.toISOString().split('T')[0];
        }
        return this.startDate;
    }

    getFormattedEndDate() {
        if (this.endDate instanceof Date) {
            return this.endDate.toISOString().split('T')[0];
        }
        return this.endDate;
    }

    // Helper method to format time for API
    getFormattedStartTime() {
        return this.startTime.includes(':') ? this.startTime : this.startTime + ":00";
    }

    // Method to create a copy of the object
    clone() {
        return new AvailabilityInterval(
            this.experienceId,
            this.guideId,
            this.startDate,
            this.endDate,
            this.startTime,
            this.frequency,
            this.minPeople,
            this.maxPeople,
            this.isActive
        );
    }
}

